<template>
	<div>
		<ExpensesTabs 
			:tab="'Claims'"
			@tab="onTabChange($event)"
		/>
		<ListClaims 
			v-if="isList" 
			:color="color" 
			:currencies="currencies"
			@create-claim="onCreateClaim()"
			@row-click="onRowClick($event)"
		/>
	</div>
</template>
<script>
import ListClaims from '@/views/expenses/claims/list_claims';
import ExpensesTabs from "@/views/expenses/commond/expenses_tabs";

export default {
	name: 'Claims',
	data() {
		return {
			isList: true,
			color: this.$attrs.color ? this.$attrs.color : '#FFB946',
			currencies: [],
		}
	},
	created() {
		this.listCountries();
		this.update_breadcrumb();
	},
	components: {
		ExpensesTabs,
		ListClaims,
	},
	methods: {
		listCountries() {
			const url = `/api/config/country`;

			return axios
				.get(url, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then((val) => {
					const { status, data, reason } = val.data;

					if (status == "OK") {
						if (data.length !== 0) {
							const currencies_by_id = new Map();

							data.forEach(country => {
								if (!country.currency) return;

								const { currency, ...country_details } = country;
								if (!currencies_by_id.has(currency.id)) {
									currencies_by_id.set(currency.id, Object.assign({}, currency, {
										countries: []
									}));
								}

								currencies_by_id.get(currency.id).countries.push(country_details);
							});

							this.currencies = Array.from(currencies_by_id.values());
						}
					} else {
						this.error_msg = reason;
						this.loading = false;
					}
				})
				.catch((e) => {
					this.error_msg = e.message;
					this.loading = false;
				});
		},
		onCreateClaim() {
			this.$router.push({ name: 'New Claim' });
		},
		onRowClick(claim_id) {
			this.$router.push({ name: 'Edit Claim', params: { id: claim_id } });
		},
		onTabChange(current_tab) {
			this.$router.push({ name: current_tab });
		},
		update_breadcrumb() {
			// add this page to our breadcrumbs
			this.$store.commit("push_breadcrumb", {
				exact: true,
				text: 'Claims',
				to: '/expenses/claims'
			});
		},
	}
}
</script>